var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kk-aux-menu-bar d-md-none",class:{
    'kk-aux-menu-bar--hidden': !_vm.visible,
    'kk-aux-menu-bar--expanded': _vm.expanded,
  }},[_c('div',{staticClass:"kk-aux-menu-bar__bg"}),_vm._v(" "),_vm._t("default",null,{"toggle":_vm.onChildToggle,"expanded":_vm.expanded})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }